<template>
  <div class="addressBox" >
    <h4 class="title">
      <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>运费结算</span>
    </h4>
    <div>
      <el-form-item label="结算方:" prop="payee" class="width1">
        <el-select  v-model="goodform.payee" filterable placeholder="请选择"  @change="payeeChange">
          <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
    </div>
    <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border >
      <el-table-column label="结算方式" min-width="100">
        <template >
          <div>
            <el-form-item label=""    class="table_error"  prop="expenditurePattern">
              <el-select  v-model="goodform.expenditurePattern"  placeholder="请选择" @change="zcfsChange">
                <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
       <el-table-column label="是否开票" min-width="120">
        <template >
          <div>
            <el-form-item label=""   class="table_error" >
              <el-select  v-model="goodform.makeTicketYn" filterable placeholder="请选择" >
                <el-option  label="是" value="是" ></el-option>
                <el-option  label="否" value="否" ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
        <el-table-column label="是否一票制" min-width="120">
        <template >
          <div>
            <el-form-item label=""    class="table_error" >
              <el-select  v-model="goodform.ticketSystemYn" filterable placeholder="请选择">
                <el-option  label="是" value="是" ></el-option>
                <el-option  label="否" value="否" ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="计价方式" min-width="100">
        <template >
          <div>
            <el-form-item label=""    class="table_error" prop="freightPricingType">
              <el-select  v-model="goodform.freightPricingType"  placeholder="请选择" @change="jijiaChange">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费单价(元)" min-width="100">
        <template slot="header" >
          <div>运费单价(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""   class="table_error" prop="freightUnitPrice" v-if="goodform.freightPricingType!=1" >
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightUnitPrice"  ></el-input>
            </el-form-item>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费金额(元)" min-width="100">
        <template slot="header" >
          <div>运费金额(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="freightAmount" >
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightAmount"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getDictionaryDetailList, findCustomerInfoList } from '@/api/newTMS'
import { selectTMSTenantListByCustom } from '@/api/newCrm'
import { toFixed } from '@/utils/util'
export default {
  name: 'shouru',
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    },
    kehuList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      ZHFSlist: [],
      SRJJlist: []
    }
  },
  created () {
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.goodform, 'freightTaxRate', null)
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
  },
  methods: {
    // 收款方改变
    payeeChange (e) {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.payeeCode = json[0].tenantCode
      this.$set(this.goodform, 'periodDays', json[0].periodDays)
      this.$set(this.goodform, 'periodDaysType', json[0].periodDaysType)
    },
    // 支出方式修改
    zcfsChange (e) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      this.goodform.expenditurePatternName = json[0].showName
    },
    // 运费计价修改
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.goodform.freightPricingTypeName = json[0].showName
      if (this.goodform.freightPricingType == 1) {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      } else {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      }
    }
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.orderWeight && this.goodform.freightUnitPrice) {
          this.$set(this.goodform, 'freightAmount', toFixed(accMul(this.goodform.orderWeight, this.goodform.freightUnitPrice), 2))
        }

        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.tableBox{
  width:900px;
}
.width1  /deep/.el-input__inner{
  width: 260px;
}
.tableBox /deep/.el-input__inner{
  width: 100px;
}
</style>
